const TOGGLE_MENU = 'TOGGLE_MENU'
const TOGGLE_MAINE_MENU = 'TOGGLE_MAINE_MENU'
const FULL_MAINE_MENU = 'FULL_MAINE_MENU'
const TOGGLE_LOADING_ON = 'TOGGLE_LOADING_ON'
const TOGGLE_LOADING_OFF = 'TOGGLE_LOADING_OFF'
const SET_SEARCH = 'SET_SEARCH'

export default {
  namespaced: true,
  state: {
    menuOpened: false,
    mainMenuStatusL: false,
    showTransitionClass: false,
    loading: false,
    search: ''
  },
  getters: {
    menuIsOpened (state) {
      return state.menuOpened
    },
    menuMainIsOpened (state) {
      return state.mainMenuStatusL
    },
    showTransitionClass (state) {
      return state.showTransitionClass
    },
    search: s => s.search
  },
  mutations: {
    [SET_SEARCH] (state, word) {
      state.search = word
    },
    [TOGGLE_MENU] (state) {
      state.menuOpened = !state.menuOpened
      if (state.menuOpened) {
        document.body.classList.add('body-fixed', 'show-block-mobile')
      } else {
        document.body.classList.remove('body-fixed', 'show-block-mobile')
      }
    },
    [TOGGLE_LOADING_ON] (state) {
      state.loading = true
      document.body.classList.add('preload')
    },
    [TOGGLE_LOADING_OFF] (state) {
      state.loading = false
      document.body.classList.remove('preload')
    },
    [TOGGLE_MAINE_MENU] (state) {
      state.mainMenuStatusL = !state.mainMenuStatusL

      if (state.mainMenuStatusL) {
        state.showTransitionClass = true
      } else {
        setTimeout(function () {
          state.showTransitionClass = false
        }, 250)
      }
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
        console.log('dispatchEvent')
      }, 400)
    },
    [FULL_MAINE_MENU] (state) {
      state.mainMenuStatusL = true
    }
  },
  actions: {
    toggleMenu ({ commit }) {
      commit(TOGGLE_MENU)
    },
    toggleMainMenu ({ commit }) {
      commit(TOGGLE_MAINE_MENU)
    },
    fullMainMenu ({ commit }) {
      commit(FULL_MAINE_MENU)
    },
    toggleLoading ({ commit }, status) {
      if (status) {
        commit(TOGGLE_LOADING_ON)
      } else {
        commit(TOGGLE_LOADING_OFF)
      }
    }
  }
}
